import { createReducer, on } from '@ngrx/store';
import { RFI, RFIFilterParams, RFIListingItem } from './rfi.types';
import { RFIActions } from './rfis.actions';
import { viewProjectActions } from '@app/store/view-project/view-project.actions';

export const rfisFeatureKey = 'rfis';

export interface RFIState {
  RFIs: RFIListingItem[];
  selectedRFI: RFI | null;
  loading: boolean; // list loading
  loadingDetails: boolean;
  creating: boolean;
  updatingIds: number[]; // track ids currently being updated
  deletingIds: number[]; // track ids being deleted
  error?: string | null;
  nextRFINumber: string | null;
  filters: Partial<RFIFilterParams>;
  lastPageEmpty: boolean;
}

export const initialRFIState: RFIState = {
  RFIs: [],
  selectedRFI: null,
  loading: false,
  loadingDetails: false,
  creating: false,
  updatingIds: [],
  deletingIds: [],
  error: null,
  nextRFINumber: null,
  filters: {},
  lastPageEmpty: false,
};

export const rfisReducer = createReducer(
  initialRFIState,
  on(
    viewProjectActions.refreshNeeded,
    RFIActions.loadRFIs,
    RFIActions.filtersChanged,
    RFIActions.updateRFISuccess,
    RFIActions.createRFISuccess,
    RFIActions.onOpenRFIListing,
    RFIActions.deleteRFISuccess,
    (state): RFIState => ({ ...state, loading: true, error: null }),
  ),
  on(RFIActions.filtersChanged, (state, action): RFIState => {
    return {
      ...state,
      loading: true,
      filters: {
        ...state.filters,
        ...action.filters,
      },
    };
  }),
  on(RFIActions.loadRFIsSuccess, (state, action): RFIState => {
    const lastPageEmpty = action.rfis?.length === 0;
    const page = action.filters?.page;
    const RFIs = page === 1 ? action.rfis : [...state.RFIs, ...action.rfis];

    return {
      ...state,
      loading: false,
      RFIs,
      error: null,
      lastPageEmpty,
      filters: {
        ...state.filters,
        ...action.filters,
      },
    };
  }),
  on(
    RFIActions.loadRFIsFailure,
    (state, action): RFIState => ({
      ...state,
      loading: false,
      error: action.error,
    }),
  ),
  on(RFIActions.onCreateRFI, (state): RFIState => ({ ...state, creating: true, error: null })),
  on(
    RFIActions.createRFISuccess,
    (state, action): RFIState => ({
      ...state,
      creating: false,
      nextRFINumber: null,
    }),
  ),
  on(
    RFIActions.createRFIFailure,
    (state, action): RFIState => ({ ...state, creating: false, error: action.error }),
  ),
  on(
    RFIActions.updateRFI,
    (state, action): RFIState => ({
      ...state,
      updatingIds: [...state.updatingIds, action.rfiId],
      error: null,
    }),
  ),
  on(RFIActions.updateRFISuccess, (state, action): RFIState => {
    return {
      ...state,
      updatingIds: state.updatingIds.filter((id) => id !== action.rfi.id),
      selectedRFI: state.selectedRFI?.id === action.rfi.id ? action.rfi : state.selectedRFI,
    };
  }),
  on(
    RFIActions.updateRFIFailure,
    (state, action): RFIState => ({
      ...state,
      updatingIds: state.updatingIds.filter((id) => id !== action.rfiId),
      error: action.error,
    }),
  ),
  // on(
  //   RFIActions.deleteRFI,
  //   (state, action): RFIState => ({
  //     ...state,
  //     deletingIds: [...state.deletingIds, action.rfiId],
  //     error: null,
  //   }),
  // ),
  // on(
  //   RFIActions.deleteRFISuccess,
  //   (state, action): RFIState => ({
  //     ...state,
  //     deletingIds: state.deletingIds.filter((id) => id !== action.rfiId),
  //     RFIs: state.RFIs.filter((item) => item.id !== action.rfiId),
  //     selectedRfiId: state.selectedRfiId === action.rfiId ? null : state.selectedRfiId,
  //   }),
  // ),
  // on(
  //   RFIActions.deleteRFIFailure,
  //   (state, action): RFIState => ({
  //     ...state,
  //     deletingIds: state.deletingIds.filter((id) => id !== action.rfiId),
  //     error: action.error,
  //   }),
  // ),
  on(
    RFIActions.onOpenRFIDetails,
    (state, action): RFIState => ({ ...state, loadingDetails: true }),
  ),
  on(
    RFIActions.loadRFIDetailsSuccess,
    (state, action): RFIState => ({
      ...state,
      selectedRFI: action.rfi,
      loadingDetails: false,
    }),
  ),
  on(
    RFIActions.loadRFIDetailsFailure,
    (state, action): RFIState => ({
      ...state,
      loadingDetails: false,
      error: action.error,
    }),
  ),
  on(RFIActions.loadRFINumberSuccess, (state, action) => {
    return {
      ...state,
      nextRFINumber: action.rfiNumber,
    };
  }),
  on(RFIActions.onProjectViewClosed, (): RFIState => ({ ...initialRFIState })),
);
